import React, { useState, useEffect } from "react"
import { Link } from "react-router-dom"
import { collection, onSnapshot } from 'firebase/firestore'
import { signInAnonymously, onAuthStateChanged } from 'firebase/auth'
import { db, auth } from '../../firebase/firebase'
import { t } from '../../components/i18n/i18n'
import LikeButton from '../../components/LikeButton'
import back from "../../assets/images/elements/archiveHeader.jpg"
import { articlesData } from "../../assets/data/articles"

export const Resources = () => {
  const [searchTerm, setSearchTerm] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const articlesPerPage = 6;
  const [anonUid, setAnonUid] = useState(null)
  const [articleCounts, setArticleCounts] = useState({})

  useEffect(() => {
    const unsub = onAuthStateChanged(auth, async (user) => {
      if (user) setAnonUid(user.uid)
      else {
        const cred = await signInAnonymously(auth)
        setAnonUid(cred.user.uid)
      }
    })
    return unsub
  }, [])

  useEffect(() => {
    const unsub = onSnapshot(collection(db, 'articles'), snap => {
      const counts = {}
      snap.docs.forEach(d => { counts[d.id] = d.data().likesCount || 0 })
      setArticleCounts(counts)
    })
    return unsub
  }, [])

  const handleSearch = event => {
    setSearchTerm(event.target.value);
    // 3. Скидаємо на першу сторінку при кожному новому пошуку
    setCurrentPage(1);
  };

  const filteredArticles = articlesData.filter((article) => {
    if (!searchTerm.trim()) return true;

    const searchWords = searchTerm.trim().toLowerCase().split(/\s+/);

    const translatedTitle = t(article.titleKey) ? t(article.titleKey).toLowerCase() : '';
    const translatedAuthor = t(article.authorKey) ? t(article.authorKey).toLowerCase() : '';
    const translatedDesc = t(article.descriptionKey) ? t(article.descriptionKey).toLowerCase() : '';

    const allKeywords = [...(article.keywords_ua || []), ...(article.keywords_en || [])].map(k => k.toLowerCase());

    return searchWords.every(word => {
      return (
        translatedTitle.includes(word) ||
        translatedAuthor.includes(word) ||
        translatedDesc.includes(word) ||
        allKeywords.some((keyword) => keyword.includes(word))
      );
    });
  });

  // 4. Логіка вираховування статей для поточної сторінки
  const indexOfLastArticle = currentPage * articlesPerPage;
  const indexOfFirstArticle = indexOfLastArticle - articlesPerPage;
  const currentArticles = filteredArticles.slice(indexOfFirstArticle, indexOfLastArticle);

  // Вираховуємо загальну кількість сторінок
  const totalPages = Math.ceil(filteredArticles.length / articlesPerPage);

  // Функція для зміни сторінки
  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  return (
    <section className='blog'>
      <div className='container_100'>
        <div className='backImg15'>
          <img src={back} alt='' />
          <div className='text_container_dark_15_top'>
            <div className='h1_15 margin0'>{t("resourcesHeader")}</div>
            <center>
              <input
                type="text"
                placeholder={t("search")}
                value={searchTerm}
                onChange={handleSearch}
              />
            </center>
          </div>
        </div>

        <div className='container boxItems'>
          <br />

          <div style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(450px, 1fr))',
            gap: '30px'
          }}>
            {/* 5. Мапимо не всі відфільтровані, а тільки поточні статті (currentArticles) */}
            {currentArticles.map((article) => (

              <div className='box' key={article.id} style={{
                display: 'flex',
                flexDirection: 'row',
                gap: '20px',
                padding: '15px',
                border: '1px solid #eaeaea',
                borderRadius: '8px',
                backgroundColor: '#fff'
              }}>

                <div className='img-container' style={{
                  flex: '0 0 160px',
                  overflow: 'hidden',
                  borderRadius: '6px'
                }}>
                  <Link to={article.url}>
                    <img
                      src={article.img}
                      alt={t(article.titleKey)}
                      style={{
                        width: '100%',
                        height: '100%',
                        objectFit: 'cover',
                        display: 'block',
                        transition: 'transform 0.3s ease'
                      }}
                      onMouseOver={(e) => e.currentTarget.style.transform = 'scale(1.05)'}
                      onMouseOut={(e) => e.currentTarget.style.transform = 'scale(1)'}
                    />
                  </Link>
                </div>

                <div className='details' style={{
                  flex: '1',
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'space-between'
                }}>
                  <div>
                    <Link to={article.url} style={{ textDecoration: 'none' }}>
                      <h3 className='menuColor' style={{ fontSize: '1.2rem', marginBottom: '8px', lineHeight: '1.3' }}>
                        {t(article.titleKey)}
                      </h3>
                    </Link>
                    <p style={{ color: '#777', fontSize: '0.9rem', marginBottom: '12px' }}>
                      <em>{t(article.authorKey)}</em>
                    </p>
                    <p style={{ color: '#444', fontSize: '0.95rem', lineHeight: '1.5', marginBottom: '15px' }}>
                      {t(article.descriptionKey)}
                    </p>
                  </div>

                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: '4px' }}>
                    <Link to={article.url} className='readMore' style={{
                      fontWeight: 'bold',
                      textDecoration: 'none',
                    }}>
                      {t("resourceReadMore")} →
                    </Link>
                    <LikeButton
                      itemId={article.id}
                      count={articleCounts[article.id] || 0}
                      anonUid={anonUid}
                      collectionName='articles'
                    />
                  </div>
                </div>

              </div>
            ))}
          </div>

          {filteredArticles.length === 0 && (
            <div style={{ textAlign: 'center', marginTop: '20px', color: '#777' }}>
              Нічого не знайдено
            </div>
          )}

          {/* 6. Блок пагінації (відображається тільки якщо сторінок більше ніж 1) */}
          {totalPages > 1 && (
            <div style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              gap: '10px',
              marginTop: '40px'
            }}>
              {/* Кнопка "Назад" */}
              <button
                onClick={() => setCurrentPage(prev => Math.max(prev - 1, 1))}
                disabled={currentPage === 1}
                style={{
                  padding: '8px 12px',
                  cursor: currentPage === 1 ? 'not-allowed' : 'pointer',
                  backgroundColor: currentPage === 1 ? '#f0f0f0' : '#fff',
                  border: '1px solid #ccc',
                  borderRadius: '4px',
                  color: currentPage === 1 ? '#999' : '#333'
                }}
              >
                ←
              </button>

              {/* Номери сторінок */}
              {[...Array(totalPages)].map((_, index) => {
                const pageNum = index + 1;
                return (
                  <button
                    key={pageNum}
                    onClick={() => paginate(pageNum)}
                    style={{
                      padding: '8px 14px',
                      cursor: 'pointer',
                      backgroundColor: currentPage === pageNum ? '#b22222' : '#fff',
                      color: currentPage === pageNum ? '#fff' : '#333',
                      border: '1px solid',
                      borderColor: currentPage === pageNum ? '#b22222' : '#ccc',
                      borderRadius: '4px',
                      fontWeight: currentPage === pageNum ? 'bold' : 'normal'
                    }}
                  >
                    {pageNum}
                  </button>
                )
              })}

              {/* Кнопка "Вперед" */}
              <button
                onClick={() => setCurrentPage(prev => Math.min(prev + 1, totalPages))}
                disabled={currentPage === totalPages}
                style={{
                  padding: '8px 12px',
                  cursor: currentPage === totalPages ? 'not-allowed' : 'pointer',
                  backgroundColor: currentPage === totalPages ? '#f0f0f0' : '#fff',
                  border: '1px solid #ccc',
                  borderRadius: '4px',
                  color: currentPage === totalPages ? '#999' : '#333'
                }}
              >
                →
              </button>
            </div>
          )}

        </div>

      </div>
    </section>
  )
}
